import Nullstack from 'nullstack';
export default function IconJetpack({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-jetpack",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 6a3 3 0 1 0 -6 0v7h6v-7z"
  }), "   ", Nullstack.element("path", {
    d: "M14 13h6v-7a3 3 0 0 0 -6 0v7z"
  }), "   ", Nullstack.element("path", {
    d: "M5 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
  }), "   ", Nullstack.element("path", {
    d: "M15 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
  }), "   ", Nullstack.element("path", {
    d: "M10 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 11h4"
  }), " ");
}